<template>
  <img src="../../../assets/images/delete.png" alt="Delete">
</template>

<script>
export default {
  name: 'Delete'
}
</script>